import { Component, OnInit, ViewChild } from '@angular/core'
import { ReadyToPayViewODataService, IQuickFilter } from '@exchange/domain/.'
import { GridSize, GridWrapperComponent } from 'common-components'

@Component({
  selector: 'app-pending-payment-list',
  templateUrl: './pending-payment-list.component.html',
  standalone: false
})
export class PendingPaymentListComponent implements OnInit {
  @ViewChild('grid', { static: true }) grid: GridWrapperComponent
  GridSize = GridSize
  defaultFilter = "Status eq 'Generating Provider Remittance'"

  constructor(private readyToPayService: ReadyToPayViewODataService) {}

  ngOnInit() {
    this.initializeGrid()
  }

  initializeGrid() {
    this.grid.gridOptions.context = {
      canEdit: false,
      canDelete: false
    }

    this.grid.gridOptions.columnDefs = [
      {
        headerName: 'Adjudication Type',
        field: 'AdjudicationTypeName',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Provider NPI',
        field: 'Npi',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep', defaultOption: 'equals' },
        width: 150,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'Provider Name',
        field: 'Name',
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 200,
        cellRenderer: GridWrapperComponent.TooltipRenderer()
      },
      {
        headerName: 'CHI Claim ID',
        field: 'ClaimId',
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 100
      },
      {
        headerName: 'Line #',
        field: 'ServiceLineNumber',
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 100
      },
      {
        headerName: 'Pay Amount',
        field: 'PayAmount',
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' },
        width: 100,
        cellRenderer: GridWrapperComponent.CurrencyRenderer()
      }
    ]

    this.grid.defaultFilter = this.defaultFilter
    this.grid.odata = this.readyToPayService
  }

  filterGrid(quickFilter: IQuickFilter) {
    this.grid.defaultFilter = `${this.defaultFilter} and ${quickFilter.odataFilter}`
    this.refresh()
  }

  resetGridFilter() {
    this.grid.defaultFilter = this.defaultFilter
    this.refresh()
  }

  refresh() {
    this.grid.getData()
  }
}
